export const fontFamilies = {
  heading: '"sohne-var", "Helvetica Neue", "Arial", sans-serif',
  body: '"sohne-var", "Helvetica Neue", "Arial", sans-serif',
  mono: 'SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace',
} as const;

export const typeScale = { xs: 9, sm: 11, md: 13, lg: 17, xl: 23, '2xl': 31, '3xl': 39 } as const;

export const typography = {
  pageTitle: {
    fontFamily: fontFamilies.heading,
    fontSize: 24,
    lineHeight: 1.1,
    fontWeight: 500,
    letterSpacing: -0.5,
  },
  sectionTitle: {
    fontFamily: fontFamilies.heading,
    fontSize: typeScale.xl,
    lineHeight: 1.25,
    fontWeight: 500,
    letterSpacing: -0.2,
  },
  body: { fontFamily: fontFamilies.body, fontSize: 15, lineHeight: 1.6, fontWeight: 400 },
  bodyMuted: {
    fontFamily: fontFamilies.body,
    fontSize: 15,
    lineHeight: 1.6,
    fontWeight: 400,
  },
  label: {
    fontFamily: fontFamilies.body,
    fontSize: typeScale.sm,
    lineHeight: 1.4,
    fontWeight: 600,
    letterSpacing: 0.2,
    textTransform: 'uppercase',
  },
  labelTitle: {
    fontFamily: fontFamilies.body,
    fontSize: typeScale.sm,
    lineHeight: 1.4,
    fontWeight: 600,
    letterSpacing: 0,
    textTransform: 'none',
  },
  caption: {
    fontFamily: fontFamilies.body,
    fontSize: typeScale.xs,
    lineHeight: 1.4,
    fontWeight: 500,
    letterSpacing: 0.2,
  },
  mono: { fontFamily: fontFamilies.mono, fontSize: typeScale.sm, lineHeight: 1.5, fontWeight: 500 },
} as const;
